import React, { useEffect, useState } from 'react';
import styles from './line-graph.module.scss';
import colors from '../../sass-utils/colors.module.scss';
import posed from 'react-pose';
import { GraphData } from '../../interfaces';
import { Icon } from '../icon';

interface GraphProps {
  data: GraphData[];
  color?: string;
}

const InnerBar = posed.div({
  ready: {
    transform: ({ scaleVal }: { scaleVal: number }) => `scaleX(${scaleVal})`,
    opacity: 1,
  },
  initial: {
    transform: 'scaleX(0)',
    opacity: 0,
  },
});

export const LineGraph: React.FC<GraphProps> = ({ data, color }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    timeout = setTimeout(() => {
      setReady(true);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const lines = data.map((line, index) => {
    const scaleVal = line.value / line.max;
    const backgroundColor = line.color ? colors[line.color] : color ? colors[color] : colors.blue;

    return (
      <div className={styles.line} key={index}>
        <div className={styles.bar}>
          <InnerBar
            className={styles.innerBar}
            style={{ backgroundColor }}
            scaleVal={scaleVal}
            pose={ready ? 'ready' : 'initial'}
            poseKey={scaleVal}
          />
        </div>
        {line.icon ? (
          <div className={styles.iconLabel}>
            <Icon type={line.icon} label={line.title} />
            {line.title}
          </div>
        ) : (
          <div className={styles.label}>{line.title}</div>
        )}
        <div className={styles.value}>
          {line.value}
          {line.unit && line.unit === '%' ? line.unit : ` ${line.unit}`}
        </div>
      </div>
    );
  });

  return <div className={styles.lines}>{lines}</div>;
};
